import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  Button,
  Tooltip,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import messages from './messages';

const WorksheetButton = ({ disabled, intl, handleOpenModal }) => {
  return (
    <Button
      variant={'primarySubtle'}
      disabled={disabled}
      intl={intl}
      onClick={() =>
        handleOpenModal({
          modalType: 'generateProjectWorksheet',
        })
      }
    >
      <FormattedMessage {...messages.generateProjectWorksheet} />
    </Button>
  );
};

const GenerateProjectWorksheetButton = ({
  disabled,
  showToolTip,
  intl,
  handleOpenModal,
}) => {
  return (
    <>
      {showToolTip ? (
        <Tooltip
          id={'generateRDProjectWorksheetTooltip'}
          title={
            <FormattedMessage {...messages.mustSaveMonthlyMortgagePayment} />
          }
        >
          <WorksheetButton
            disabled={disabled}
            intl={intl}
            handleOpenModal={handleOpenModal}
          />
        </Tooltip>
      ) : (
        <WorksheetButton
          disabled={disabled}
          intl={intl}
          handleOpenModal={handleOpenModal}
        />
      )}
    </>
  );
};

export default GenerateProjectWorksheetButton;
